import { Link } from 'react-router-dom';
import { Brain } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SEOHead } from '../components/SEOHead';

export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <>
      <SEOHead 
        title={t('error.404.title') + ' | ABCbrain.xyz'}
        description={t('error.404.message')}
      />
      
      <div className="flex flex-col items-center justify-center min-h-[50vh] text-center">
        <Brain className="h-16 w-16 text-gray-400" />
        <h1 className="mt-4 text-2xl font-bold text-gray-900">
          {t('error.404.title')}
        </h1>
        <p className="mt-2 text-gray-600">
          {t('error.404.message')}
        </p>
        <Link 
          to="/"
          className="mt-6 inline-block bg-primary-500 text-white py-2 px-4 rounded-lg hover:bg-primary-600 transition-colors"
        >
          {t('common.home')}
        </Link>
      </div>
    </>
  );
}